module.exports = __webpack_public_path__ + "img/shape_rectangle--black.0ae8cfe.png";